import { createContext, useContext } from "react";
import type { SmallCalculatorContextType } from "./SmallCalculatorContext.type";

export const SmallCalculatorContext = createContext<SmallCalculatorContextType<any, Record<any, any>>>({
	// Settings
	initialStep: undefined,
	bottomLogo: true,
	colorScheme: "dark",
	classNames: {
		card: undefined,
	},

	// Status
	stepHistory: [],
	activeStep: undefined,
	isLoading: false,
	stepValues: {},

	// Callbacks
	onStep: async (_stepId: string, _data: unknown) => Promise.resolve(),
	onChange: (_stepId: string, _data: unknown) => undefined,
	onError: (_stepId: string, _error: Error) => undefined,
	goBack: () => undefined,
});

export const useSmallCalculator = () => {
	const context = useContext(SmallCalculatorContext);
	if (context === undefined) {
		throw new Error("useSmallCalculator must be used within a SmallCalculator");
	}
	return context;
};
